import { useState } from "react";

const ChatComponent = () => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div style={{ height: "70vh" }}>
      {isLoading && (
        <div className="text-center " style={{ padding: "20% 0px" }}>
          <div class="spinner-border text-success " role="status"></div>
        </div>
      )}
      <iframe
        src="https://tawk.to/chat/6901e057657964195024a5e4/1j8nl8lpk"
        style={{ width: "100%", height: "100%", border: "none" }}
        title="Chat"
        onLoad={() => {
          setIsLoading(false);
        }}
      ></iframe>
    </div>
  );
};

export default ChatComponent;
